import { ThemeConfig } from 'antd'

/**
 * The specificity antd writes its styles at, shared by `genCss.tsx`, which
 * extracts `public/antd.min.css` at it, and `App.tsx`, which injects the rest.
 * Extracted `high` but injected at antd's default `low`, a style rendered only
 * on demand — a Tag's preset colour — lost to the extracted grey base: every
 * `<Tag color="green">` showed grey (27 Oct. 2026).
 */
export const ANTD_HASH_PRIORITY = 'high' as const

export const theme: ThemeConfig = {
  token: {
    colorBgLayout: '#ECF8F6',
  },
  components: {
    Layout: {
      headerBg: '#548052',
      siderBg: '#548052',
      triggerBg: '#679C64',
    },
    Table: {
      cellFontSize: 12,
      cellFontSizeMD: 12,
      cellFontSizeSM: 12,
      cellPaddingBlock: 8,
      cellPaddingBlockMD: 8,
      cellPaddingBlockSM: 8,
    },
  },
}
